import { pathParamsToQuery } from "../utils/helpers";
import { toShopDomainName } from "../utils/shop";

export enum AdminSections {
  SHOPS = "shops"
}

export enum SearchParamsAdmin {
  QUERY = 'query',
  EMULATE = 'emulate',
}

export type PathSearchParams = {
  home: undefined;
  admin: { [key in SearchParamsAdmin]?: string };
  appPlanSelectionPage: undefined;
};

type Params<T extends Record<string, string> | never = never> = T extends never
  ? undefined
  : T;

type PathWithParams<T = undefined> = T extends undefined
  ? (params?: undefined) => string
  : (params?: T) => string;

type Paths = {
  home: PathWithParams;
  admin: PathWithParams<PathSearchParams["admin"]>;
  adminSection: (section: AdminSections) => string;
  shopShopifyAdminPath: (shop: string, path: string, params?: Params<{ [key: string]: string }>) => string;
  universalAppPath: (appHandle: string, path: string, params?: Params<{ [key: string]: string }>) => string;
  appPlanSelectionPage: (appHandle: string, shop: string) => string;
  shopAppPath: (appHandle: string, shop: string, path: string, params?: Params<{ [key: string]: string }>) => string;
  firestoreUri: (project: string, path: string) => string;
}

export const paths: Paths = {
  home: () => `/`,
  admin: (params) => `/admin${pathParamsToQuery(params)}`,
  adminSection: (section) => `/admin/${section}`,
  shopShopifyAdminPath: (shop, path, params) => `https://admin.shopify.com/store/${toShopDomainName(shop)}${path}${pathParamsToQuery(params)}`,
  universalAppPath: (appHandle, path, params) => `https://admin.shopify.com/apps/${appHandle}${path}${pathParamsToQuery(params)}`,
  appPlanSelectionPage: (appHandle, shop) => paths.shopShopifyAdminPath(shop, `/charges/${appHandle}/pricing_plans`),
  shopAppPath: (appHandle, shop, path, params) => paths.shopShopifyAdminPath(shop, `/apps/${appHandle}${path}${pathParamsToQuery(params)}`),
  firestoreUri: (project, path) => `https://console.firebase.google.com/u/0/project/${project}/firestore/databases/-default-/data/${path}`,
};
